export default __webpack_public_path__ + "images/assets/2759b15acb4f59a37931de3f3a25e1d7.svg";